import { useQueryClient } from '@tanstack/react-query'
import { useRealtime } from '@/lib/ws/useRealtime'

export function RenewalsRealtime() {
  const qc = useQueryClient()
  useRealtime(
    (event) => event === 'renewal.due',
    () => {
      void qc.invalidateQueries({ queryKey: ['renewals'] })
    },
  )
  return null
}
